import { createSelector } from 'reselect';

import { RootState } from '../../reducers';

export const getHMS = (state: RootState) => state.entities.hms;

export const getHMSNames = createSelector(getHMS, (hms) => hms.map((elem) => elem.hmsName));
